import { FC } from 'react'
import styles from 'components/atoms/inputs/Select/Dropdown/Dropdown.styl'
import cn from 'classnames'

type DropdownProps = {
  className?: string
}
export const Dropdown: FC<DropdownProps> = (props) => {
  const { children, className } = props
  return (
    <div className={ cn(styles.dropdown, className) }>
      { children }
    </div>
  )
}
